import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
  {
    _id: 1005,
    title: "Journal",
    link: "/journal",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "Cap for Boys",
    // price: "35.00",
    color: "Blank and White",
    badge: true,

  },
  {
    _id: "202",
    img: newArrFour,
    productName: "Tea Table",
   
    color: "Gray",
    badge: true,

  },
  {
    _id: "203",
    img: spfThree,
    productName: "Headphones",
   
    color: "Mixed",
    badge: true,

  },
  {
    _id: "204",
    img: spfFour,
    productName: "Sun glasses",
   
    color: "Black",
    badge: true,
    
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: spfOne,
    productName: "Cap for Boys",

    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1002,
    img: spfTwo,
    productName: "Tea Table",
    
    color: "Gray",
    badge: true,

  },
  {
    _id: 1003,
    img: spfThree,
    productName: "Headphones",
  
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1004,
    img: spfFour,
    productName: "Sun glasses",
    
    color: "Black",
    badge: true,

  },
  {
    _id: 1005,
    img: bestSellerOne,
    productName: "Flower Base",

    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1006,
    img: bestSellerTwo,
    productName: "New Backpack",
  
    color: "Gray",
    badge: false,

  },
  {
    _id: 1007,
    img: bestSellerThree,
    productName: "Household materials",
   
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1008,
    img: bestSellerFour,
    productName: "Travel Bag",
  
    color: "Black",
    badge: false,
  
  },
  {
    _id: 1009,
    img: newArrOne,
    productName: "Round Table Clock",
  
    color: "Black",
    badge: true,

  },
  {
    _id: 1010,
    img: newArrTwo,
    productName: "Smart Watch",
   
    color: "Black",
    badge: true,

  },
  {
    _id: 1011,
    img: newArrThree,
    productName: "cloth Basket",

    color: "Mixed",
    badge: true,

  },
  {
    _id: 1012,
    img: newArrFour,
    productName: "Funny toys for babies",
   
    color: "Mixed",
    badge: false,

  },
  {
    _id: 1013,
    img: newArrTwo,
    productName: "Funny toys for babies",

    color: "Mixed",
    badge: false,

  },

  {
    _id: 1014,
    img: newArrTwo,
    productName: "Smart Watch",

    color: "Black",
    badge: true,

  },
  {
    _id: 1015,
    img: newArrFour,
    productName: "Funny toys for babies",

    color: "Mixed",
    badge: false,

  },
  {
    _id: 1016,
    img: newArrTwo,
    productName: "Smart Watch",
    
    color: "Black",
    badge: true,

  },
  {
    _id: 1017,
    img: bestSellerFour,
    productName: "Travel Bag",
   
    color: "Black",
    badge: false,

  },
  {
    _id: 1018,
    img: newArrOne,
    productName: "Round Table Clock",

    color: "Black",
    badge: true,

  },
  {
    _id: 1019,
    img: newArrTwo,
    productName: "Smart Watch",
   
    color: "Black",
    badge: true,

  },
  {
    _id: 1020,
    img: newArrThree,
    productName: "cloth Basket",
  
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1021,
    img: spfThree,
    productName: "Headphones",
   
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1022,
    img: spfFour,
    productName: "Sun glasses",

    color: "Black",
    badge: true,

  },
  {
    _id: 1023,
    img: bestSellerOne,
    productName: "Flower Base",
  
    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1024,
    img: spfOne,
    productName: "Cap for Boys",
  
    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1025,
    img: spfTwo,
    productName: "Tea Table",

    color: "Gray",
    badge: true,

  },
  {
    _id: 1026,
    img: spfThree,
    productName: "Headphones",
  
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1027,
    img: spfFour,
    productName: "Sun glasses",
   
    color: "Black",
    badge: true,

  },
  {
    _id: 1028,
    img: bestSellerOne,
    productName: "Flower Base",

    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1029,
    img: bestSellerTwo,
    productName: "New Backpack",
   
    color: "Gray",
    badge: false,

  },
  {
    _id: 1030,
    img: bestSellerThree,
    productName: "Household materials",

    color: "Mixed",
    badge: true,

  },
  {
    _id: 1031,
    img: bestSellerFour,
    productName: "Travel Bag",
    
    color: "Black",
    badge: false,

  },
  {
    _id: 1032,
    img: newArrOne,
    productName: "Round Table Clock",
   
    color: "Black",
    badge: true,

  },
  {
    _id: 1033,
    img: newArrTwo,
    productName: "Smart Watch",

    color: "Black",
    badge: true,
   
  },
  {
    _id: 1034,
    img: newArrThree,
    productName: "cloth Basket",
  
    color: "Mixed",
    badge: true,

  },
  {
    _id: 1035,
    img: newArrFour,
    productName: "Funny toys for babies",

    color: "Mixed",
    badge: false,

  },
  {
    _id: 1036,
    img: newArrTwo,
    productName: "Funny toys for babies",
 
    color: "Mixed",
    badge: false,

  },
  {
    _id: 1037,
    img: newArrFour,
    productName: "Funny toys for babies",
    
    color: "Mixed",
    badge: false,

  },
  {
    _id: 1038,
    img: newArrTwo,
    productName: "Smart Watch",
    
    color: "Black",
    badge: true,

  },
  {
    _id: 1039,
    img: bestSellerFour,
    productName: "Travel Bag",
 
    color: "Black",
    badge: false,

  },
  {
    _id: 1040,
    img: newArrOne,
    productName: "Round Table Clock",
   
    color: "Black",
    badge: true,

  },
  {
    _id: 1041,
    img: newArrTwo,
    productName: "Smart Watch",
  
    color: "Black",
    badge: true,
  
  },
  {
    _id: 1042,
    img: newArrThree,
    productName: "cloth Basket",
    // price: "80.00",
  
    badge: true,

  },
  {
    _id: 1043,
    img: spfThree,
    productName: "Headphones",

    color: "Mixed",
    badge: true,

  },
  {
    _id: 1044,
    img: spfFour,
    productName: "Sun glasses",
   
    color: "Black",
    badge: true,
   
  },
  {
    _id: 1045,
    img: bestSellerOne,
    productName: "Flower Base",
  
    color: "Blank and White",
    badge: true,

  },
  {
    _id: 1046,
    img: spfOne,
    productName: "Cap for Boys",

    color: "Blank and White",
    badge: true,

  },
];
// =================== PaginationItems End here =================
